import component from '../../../../../props/component'
import form from '../../../../../props/form'
import processing from '../../../../../props/processing'

const localProps = {
  quantitySelectorAttrs: {},
  quantitySelectorListeners: {},
}
export const props = {
  ...component,
  ...form,
  ...processing,
  ...localProps
}
export default props
